import { Outlet } from "react-router-dom";

export default function BlankLayout() {

  return (
    <div className=" w-full">
      <Outlet />
    </div>
  );
}
